import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SuccessMessage from '../../accountDetailsSharedBlocks/successMessage';
import Globals, { URLS } from "../../../../utility/constants/appConstants";
import ecommEndpoints from "../../../../utility/features/endPoints/ecommEndpoints";
import OverlayLoader from "../../../loader/overlayLoader";
import BaseClient from "../../../../utility/apiClients/base/baseClient";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import changePasswordStyles from "../../../../styles/myAccount/changePassword.module.scss";

const ChangePasswordComponent = () => {
  const labels = Globals.acc;
  const { put } = BaseClient();
  const navigate = useNavigate();

  const customerInfo = useSelector((state) => state.login.customerInfo);
  const customerSummaryData = customerInfo?.[0] || null;

  const [changePasswordState, setChangePasswordState] = useState({
    showValidations: false,
    result: "",
    refresh: 0,
    isError: false,
    error: {},
    success: false,
    queryString: window.location.search !== "" ? window.location.search : "",
    loading: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const saveChanges = async () => {
    if (Object.keys(errors).length) {
      setChangePasswordState((prev) => ({
        ...prev,
        showValidations: true,
        refresh: prev.refresh + 1,
      }));
      return;
    }

    setChangePasswordState((prev) => ({ ...prev, loading: true }));

    try {
      await put(
        process.env.REACT_APP_ECOMM_URL + ecommEndpoints.changePassword(),
        {
          currentPassword: getValues("currentpassword"),
          newPassword: getValues("newpassword"),
        },
        {},
        true
      );

      setChangePasswordState((prev) => ({
        ...prev,
        success: true,
        loading: false,
      }));
    } catch ({ response }) {
      const errMsg =
        labels["ERR" + (response?.data?.code || "")] ||
        "An unexpected error occurred";
      setChangePasswordState((prev) => ({
        ...prev,
        isError: true,
        error: { message: errMsg },
        loading: false,
      }));
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    navigate(URLS.settings + changePasswordState.queryString);
  };

  return (
    <>
      {changePasswordState.loading && (
        <OverlayLoader isOpen={changePasswordState.loading} />
      )}

      {!changePasswordState.success ? (
          
        <div className={changePasswordStyles["change-password-container"]}>
          <h1 className={changePasswordStyles["change-password-title"]}>
            {labels.changePasswordTitle}
          </h1>
          <p className={changePasswordStyles["change-password-subtitle"]}>
            {labels.descriptionCP}
          </p>

          <div>
            <form onSubmit={handleSubmit(saveChanges)}>
              <div className={changePasswordStyles["change-password-content"]}>
                <div className={changePasswordStyles["password-form"]}>
                  <div className={changePasswordStyles["form-group"]}>
                    <input
                      type="password"
                      id="old-password"
                      className={changePasswordStyles["form-control"]}
                      placeholder="Current Password"
                      {...register("currentpassword", {
                        required: "Current password is required",
                      })}
                    />
                    {errors.currentpassword && (
                      <span className={changePasswordStyles["error-text"]}>
                        {errors.currentpassword.message}
                      </span>
                    )}
                  </div>

                  <div className={changePasswordStyles["form-group"]}>
                    <input
                      type="password"
                      id="new-password"
                      className={changePasswordStyles["form-control"]}
                      placeholder="New Password"
                      {...register("newpassword", {
                        required: "New password is required",
                        minLength: {
                          value: 8,
                          message: "Password must be at least 8 characters",
                        },
                      })}
                    />
                    {errors.newpassword && (
                      <span className="error-text">{errors.newpassword.message}</span>
                    )}
                  </div>

                  <div className={changePasswordStyles["form-group"]}>
                    <input
                      type="password"
                      id="confirm-password"
                      className={changePasswordStyles["form-control"]}
                      placeholder={labels.confirmNewPasswordField}
                      {...register("confirmnewpassword", {
                        required: "Please confirm your new password",
                        minLength: {
                          value: 8,
                          message: "Password must be at least 8 characters",
                        },
                        validate: (value) =>
                          value === getValues("newpassword") ||
                          "Passwords do not match",
                      })}
                    />
                    {errors.confirmnewpassword && (
                      <span className={changePasswordStyles["error-text"]}>
                        {errors.confirmnewpassword.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className={changePasswordStyles["password-rules"]} dangerouslySetInnerHTML={{ __html: labels.passwordCriteria }}></div>
              </div>
              
              <div className={changePasswordStyles["button-group"]}>
              <div className='col-12 col-md-6 col-lg-4 text-right'>
                <button
                  type="button"
                  className={`${changePasswordStyles["btn"]} ${changePasswordStyles["cancel-btn"]}`}
                  onClick={handleCancel}
                  disabled={changePasswordState.loading}
                >
                  {labels.cancel}
                </button>
              </div>
              
              <div className='col-12 col-md-6 col-lg-4 text-right'>
                <button
                  type="submit"
                  className={`${changePasswordStyles["btn"]} ${changePasswordStyles["save-btn"]}`}
                  disabled={changePasswordState.loading}
                >
                  {changePasswordState.loading ? "Saving..." : labels.saveChanges}
                </button>
              </div>
            </div>
            </form>

            {changePasswordState.isError && (
              <div className={changePasswordStyles["error-message"]}>
                {changePasswordState.error.message}
              </div>
            )}
            
          </div>
        </div>
        )
      : ( <div className={changePasswordStyles["change-password-container"]}>
            <SuccessMessage
              title="Your password has been changed successfully."
              message="Be sure to use your new password the next time you log in."
              btnText="Return to Account Settings"
              btnLink={URLS.settings}
              labels={labels}
              email={customerSummaryData?.EmailAddress}
            />
        </div>
        )
      }
    </>
  );
};

export default ChangePasswordComponent;
